import DataTable from '../../components/Table/Table'
import './acAtendimento.css'

export default function AcAtendimento(){
    return(
        <div className="home">
            <DataTable/>
        </div>
    )
}